export const imageAllowedFormats = ["jpg", "jpeg", "png", "gif"];
